import _ from 'lodash';
import {
    SET_PENS,
    SET_BADGES,
    SET_IS_LOADING,
    OPEN_CATEGORIES,
    CLOSE_CATEGORIES,
    SET_CATEGORY_FILTER,
    SET_CURRENT_DISPLAY_LOCAL,
    SET_ACTIVE_BADGES,
} from '../actions/actionCreators/overview';

const initialState = {
    pens: [],
    badges: [],
    isLoading: true,
    currentDisplayLocale: null,
    activeBadges: null,
};

export default function overview(state = initialState, action) {
    let newState = _.cloneDeep(state);
    switch (action.type) {
        case SET_PENS:
            newState.pens = action.pens;
            return newState;
        case SET_BADGES:
            newState.badges = action.badges;
            return newState;
        case SET_IS_LOADING:
            newState.isLoading = action.isLoading;
            return newState;
        case OPEN_CATEGORIES:
            newState.hasOpenedCategories = true;
            return newState;
        case CLOSE_CATEGORIES:
            newState.hasOpenedCategories = false;
            return newState;
        case SET_CATEGORY_FILTER:
            newState.filteredCategory = action.categoryId;
            return newState;
        case SET_CURRENT_DISPLAY_LOCAL:
            newState.currentDisplayLocale = action.displayLocale;
            return newState;
        case SET_ACTIVE_BADGES:
            newState.activeBadges = action.activeBadges;
            return newState;
        default:
            return state;
    }
}
